var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlertCircleError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7924 22.8036C18.3668 22.8036 22.8857 18.2847 22.8857 12.7104C22.8857 7.136 18.3668 2.61709 12.7924 2.61709C7.21804 2.61709 2.69912 7.136 2.69912 12.7104C2.69912 18.2847 7.21804 22.8036 12.7924 22.8036ZM12.7924 24.9286C19.5403 24.9286 25.0106 19.4583 25.0106 12.7104C25.0106 5.96245 19.5403 0.492188 12.7924 0.492188C6.04449 0.492188 0.574219 5.96245 0.574219 12.7104C0.574219 19.4583 6.04449 24.9286 12.7924 24.9286Z",
    fill: "#B54D09"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5268 6.87132C12.7807 6.84706 13.0341 6.92313 13.2326 7.08327C13.4312 7.2434 13.5592 7.47488 13.5892 7.72819L13.5892 13.4516C13.5592 13.7049 13.4312 13.9364 13.2326 14.0965C13.0341 14.2567 12.7807 14.3327 12.5268 14.3085C12.2729 14.3327 12.0195 14.2567 11.821 14.0965C11.6224 13.9364 11.4944 13.7049 11.4643 13.4516L11.4643 7.72819C11.4944 7.47488 11.6224 7.2434 11.821 7.08327C12.0195 6.92313 12.2729 6.84706 12.5268 6.87132Z",
    fill: "#B54D09"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5268 18.0273C12.7895 18.0273 13.0462 17.9494 13.2646 17.8035C13.483 17.6576 13.6532 17.4502 13.7538 17.2075C13.8543 16.9648 13.8806 16.6978 13.8293 16.4402C13.7781 16.1826 13.6516 15.9459 13.4659 15.7602C13.2801 15.5745 13.0435 15.448 12.7859 15.3967C12.5283 15.3455 12.2612 15.3718 12.0186 15.4723C11.7759 15.5728 11.5685 15.743 11.4225 15.9614C11.2766 16.1798 11.1987 16.4366 11.1987 16.6993C11.1987 17.0515 11.3386 17.3893 11.5877 17.6383C11.8368 17.8874 12.1746 18.0273 12.5268 18.0273Z",
    fill: "#B54D09"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertCircleError);
export default __webpack_public_path__ + "static/media/alert-circle-error.aa6e4758259d398c057219791af5f8c3.svg";
export { ForwardRef as ReactComponent };